import { render, staticRenderFns } from "./CompanyManagementModal.vue?vue&type=template&id=6212b5a1&"
import script from "./CompanyManagementModal.vue?vue&type=script&lang=js&"
export * from "./CompanyManagementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports